import { parse } from 'detect.js';

export default function detectBrowser () {
	const { browser } = parse(navigator.userAgent);
	const browserClass = browser.family.toLowerCase().replace(/\s/g, '-');
	document.body.classList.add(browserClass);
}
